import { apiServer } from 'settings/web-services/api';

export const propertyTimeSpentAuditLog = (payload) =>
  apiServer.post('/activities/property-details-time-spent', {
    payload,
  });
